module.exports = __webpack_public_path__ + "img/Logo-oliver-400.41379939.png";